"use client";

import { createBrandContext } from "@repo/dashboard-core/context";

import type { TuBrandConfig } from "@/config/brand";

export const { BrandProvider, useBrand } = createBrandContext<TuBrandConfig>();
